import { FC } from 'react';
import { formAction } from './action';
import { StartAnAgencyClientForm } from './StartAnAgencyClientForm';

export const StartAnAgencyForm: FC = () => {
	return <StartAnAgencyClientForm formAction={formAction} />;
};
